/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "včera",
        "-2": "předevčírem",
        "0": "dnes",
        "1": "zítra",
        "2": "pozítří",
        "future": {
          "few": "za {0} dny",
          "many": "za {0} dne",
          "one": "za {0} den",
          "other": "za {0} dní"
        },
        "past": {
          "few": "před {0} dny",
          "many": "před {0} dne",
          "one": "před {0} dnem",
          "other": "před {0} dny"
        }
      },
      "day-narrow": {
        "-1": "včera",
        "-2": "předevčírem",
        "0": "dnes",
        "1": "zítra",
        "2": "pozítří",
        "future": {
          "few": "za {0} dny",
          "many": "za {0} dne",
          "one": "za {0} den",
          "other": "za {0} dní"
        },
        "past": {
          "few": "před {0} dny",
          "many": "před {0} dne",
          "one": "před {0} dnem",
          "other": "před {0} dny"
        }
      },
      "day-short": {
        "-1": "včera",
        "-2": "předevčírem",
        "0": "dnes",
        "1": "zítra",
        "2": "pozítří",
        "future": {
          "few": "za {0} dny",
          "many": "za {0} dne",
          "one": "za {0} den",
          "other": "za {0} dní"
        },
        "past": {
          "few": "před {0} dny",
          "many": "před {0} dne",
          "one": "před {0} dnem",
          "other": "před {0} dny"
        }
      },
      "hour": {
        "0": "tuto hodinu",
        "future": {
          "few": "za {0} hodiny",
          "many": "za {0} hodiny",
          "one": "za {0} hodinu",
          "other": "za {0} hodin"
        },
        "past": {
          "few": "před {0} hodinami",
          "many": "před {0} hodiny",
          "one": "před {0} hodinou",
          "other": "před {0} hodinami"
        }
      },
      "hour-narrow": {
        "0": "tuto hodinu",
        "future": {
          "few": "za {0} h",
          "many": "za {0} h",
          "one": "za {0} h",
          "other": "za {0} h"
        },
        "past": {
          "few": "před {0} h",
          "many": "před {0} h",
          "one": "před {0} h",
          "other": "před {0} h"
        }
      },
      "hour-short": {
        "0": "tuto hodinu",
        "future": {
          "few": "za {0} h",
          "many": "za {0} h",
          "one": "za {0} h",
          "other": "za {0} h"
        },
        "past": {
          "few": "před {0} h",
          "many": "před {0} h",
          "one": "před {0} h",
          "other": "před {0} h"
        }
      },
      "minute": {
        "0": "tuto minutu",
        "future": {
          "few": "za {0} minuty",
          "many": "za {0} minuty",
          "one": "za {0} minutu",
          "other": "za {0} minut"
        },
        "past": {
          "few": "před {0} minutami",
          "many": "před {0} minuty",
          "one": "před {0} minutou",
          "other": "před {0} minutami"
        }
      },
      "minute-narrow": {
        "0": "tuto minutu",
        "future": {
          "few": "za {0} min",
          "many": "za {0} min",
          "one": "za {0} min",
          "other": "za {0} min"
        },
        "past": {
          "few": "před {0} min",
          "many": "před {0} min",
          "one": "před {0} min",
          "other": "před {0} min"
        }
      },
      "minute-short": {
        "0": "tuto minutu",
        "future": {
          "few": "za {0} min",
          "many": "za {0} min",
          "one": "za {0} min",
          "other": "za {0} min"
        },
        "past": {
          "few": "před {0} min",
          "many": "před {0} min",
          "one": "před {0} min",
          "other": "před {0} min"
        }
      },
      "month": {
        "-1": "minulý měsíc",
        "0": "tento měsíc",
        "1": "příští měsíc",
        "future": {
          "few": "za {0} měsíce",
          "many": "za {0} měsíce",
          "one": "za {0} měsíc",
          "other": "za {0} měsíců"
        },
        "past": {
          "few": "před {0} měsíci",
          "many": "před {0} měsíce",
          "one": "před {0} měsícem",
          "other": "před {0} měsíci"
        }
      },
      "month-narrow": {
        "-1": "minulý měs.",
        "0": "tento měs.",
        "1": "příští měs.",
        "future": {
          "few": "za {0} měs.",
          "many": "za {0} měs.",
          "one": "za {0} měs.",
          "other": "za {0} měs."
        },
        "past": {
          "few": "před {0} měs.",
          "many": "před {0} měs.",
          "one": "před {0} měs.",
          "other": "před {0} měs."
        }
      },
      "month-short": {
        "-1": "minulý měs.",
        "0": "tento měs.",
        "1": "příští měs.",
        "future": {
          "few": "za {0} měs.",
          "many": "za {0} měs.",
          "one": "za {0} měs.",
          "other": "za {0} měs."
        },
        "past": {
          "few": "před {0} měs.",
          "many": "před {0} měs.",
          "one": "před {0} měs.",
          "other": "před {0} měs."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "minulé čtvrtletí",
        "0": "toto čtvrtletí",
        "1": "příští čtvrtletí",
        "future": {
          "few": "za {0} čtvrtletí",
          "many": "za {0} čtvrtletí",
          "one": "za {0} čtvrtletí",
          "other": "za {0} čtvrtletí"
        },
        "past": {
          "few": "před {0} čtvrtletími",
          "many": "před {0} čtvrtletí",
          "one": "před {0} čtvrtletím",
          "other": "před {0} čtvrtletími"
        }
      },
      "quarter-narrow": {
        "-1": "minulé čtvrtletí",
        "0": "toto čtvrtletí",
        "1": "příští čtvrtletí",
        "future": {
          "few": "+{0} Q",
          "many": "+{0} Q",
          "one": "+{0} Q",
          "other": "+{0} Q"
        },
        "past": {
          "few": "-{0} Q",
          "many": "-{0} Q",
          "one": "-{0} Q",
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "minulé čtvrtletí",
        "0": "toto čtvrtletí",
        "1": "příští čtvrtletí",
        "future": {
          "few": "+{0} Q",
          "many": "+{0} Q",
          "one": "+{0} Q",
          "other": "+{0} Q"
        },
        "past": {
          "few": "-{0} Q",
          "many": "-{0} Q",
          "one": "-{0} Q",
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "nyní",
        "future": {
          "few": "za {0} sekundy",
          "many": "za {0} sekundy",
          "one": "za {0} sekundu",
          "other": "za {0} sekund"
        },
        "past": {
          "few": "před {0} sekundami",
          "many": "před {0} sekundy",
          "one": "před {0} sekundou",
          "other": "před {0} sekundami"
        }
      },
      "second-narrow": {
        "0": "nyní",
        "future": {
          "few": "za {0} s",
          "many": "za {0} s",
          "one": "za {0} s",
          "other": "za {0} s"
        },
        "past": {
          "few": "před {0} s",
          "many": "před {0} s",
          "one": "před {0} s",
          "other": "před {0} s"
        }
      },
      "second-short": {
        "0": "nyní",
        "future": {
          "few": "za {0} s",
          "many": "za {0} s",
          "one": "za {0} s",
          "other": "za {0} s"
        },
        "past": {
          "few": "před {0} s",
          "many": "před {0} s",
          "one": "před {0} s",
          "other": "před {0} s"
        }
      },
      "week": {
        "-1": "minulý týden",
        "0": "tento týden",
        "1": "příští týden",
        "future": {
          "few": "za {0} týdny",
          "many": "za {0} týdne",
          "one": "za {0} týden",
          "other": "za {0} týdnů"
        },
        "past": {
          "few": "před {0} týdny",
          "many": "před {0} týdne",
          "one": "před {0} týdnem",
          "other": "před {0} týdny"
        }
      },
      "week-narrow": {
        "-1": "minulý týd.",
        "0": "tento týd.",
        "1": "příští týd.",
        "future": {
          "few": "za {0} týd.",
          "many": "za {0} týd.",
          "one": "za {0} týd.",
          "other": "za {0} týd."
        },
        "past": {
          "few": "před {0} týd.",
          "many": "před {0} týd.",
          "one": "před {0} týd.",
          "other": "před {0} týd."
        }
      },
      "week-short": {
        "-1": "minulý týd.",
        "0": "tento týd.",
        "1": "příští týd.",
        "future": {
          "few": "za {0} týd.",
          "many": "za {0} týd.",
          "one": "za {0} týd.",
          "other": "za {0} týd."
        },
        "past": {
          "few": "před {0} týd.",
          "many": "před {0} týd.",
          "one": "před {0} týd.",
          "other": "před {0} týd."
        }
      },
      "year": {
        "-1": "minulý rok",
        "0": "tento rok",
        "1": "příští rok",
        "future": {
          "few": "za {0} roky",
          "many": "za {0} roku",
          "one": "za {0} rok",
          "other": "za {0} let"
        },
        "past": {
          "few": "před {0} lety",
          "many": "před {0} roku",
          "one": "před {0} rokem",
          "other": "před {0} lety"
        }
      },
      "year-narrow": {
        "-1": "minulý rok",
        "0": "tento rok",
        "1": "příští rok",
        "future": {
          "few": "za {0} r.",
          "many": "za {0} r.",
          "one": "za {0} r.",
          "other": "za {0} l."
        },
        "past": {
          "few": "před {0} r.",
          "many": "před {0} r.",
          "one": "před {0} r.",
          "other": "před {0} l."
        }
      },
      "year-short": {
        "-1": "minulý rok",
        "0": "tento rok",
        "1": "příští rok",
        "future": {
          "few": "za {0} r.",
          "many": "za {0} r.",
          "one": "za {0} r.",
          "other": "za {0} l."
        },
        "past": {
          "few": "před {0} r.",
          "many": "před {0} r.",
          "one": "před {0} r.",
          "other": "před {0} l."
        }
      }
    },
    "locale": "cs"
  });
}